import React from 'react';
import PropTypes from 'prop-types';
import Icon from '@avtechsoftware/react-component-library/src/components/common/Icon/Icon';

/* istanbul ignore next */
function TriggeredAlertNameIcon({ isAcknowledged }) {
  if (isAcknowledged) {
    return (
      <Icon icon="bell-slash" className="text-muted" />
    );
  }
  return (
    <Icon icon="bolt" className="text-muted" />
  );
}
TriggeredAlertNameIcon.propTypes = {
  isAcknowledged: PropTypes.bool.isRequired,
};
export default TriggeredAlertNameIcon;
